import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AdminLayout from '../../components/AdminLayout';
import { FaUsers, FaServicestack, FaProjectDiagram, FaBriefcase, FaEnvelope } from 'react-icons/fa';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    founders: 0,
    services: 0,
    projects: 0,
    careers: 0,
    contacts: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [foundersRes, servicesRes, projectsRes, careersRes, contactsRes] = await Promise.all([
        axios.get('/api/founders'),
        axios.get('/api/services'),
        axios.get('/api/projects'),
        axios.get('/api/careers'),
        axios.get('/api/contacts')
      ]);

      setStats({
        founders: foundersRes.data.count || 0,
        services: servicesRes.data.count || 0,
        projects: projectsRes.data.count || 0,
        careers: careersRes.data.count || 0,
        contacts: contactsRes.data.count || 0
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const statCards = [
    { label: 'Founders', value: stats.founders, icon: <FaUsers />, color: '#319795' },
    { label: 'Services', value: stats.services, icon: <FaServicestack />, color: '#2c5282' },
    { label: 'Projects', value: stats.projects, icon: <FaProjectDiagram />, color: '#00b4d8' },
    { label: 'Job Openings', value: stats.careers, icon: <FaBriefcase />, color: '#1a365d' },
    { label: 'Messages', value: stats.contacts, icon: <FaEnvelope />, color: '#d97706' }
  ];

  if (loading) {
    return (
      <AdminLayout title="Dashboard">
        <div className="loading-state">Loading...</div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout title="Dashboard">
      <div className="dashboard-container">
        <div className="stats-grid">
          {statCards.map((stat, index) => (
            <div key={index} className="stat-card" style={{ borderTopColor: stat.color }}>
              <div className="stat-icon" style={{ backgroundColor: stat.color }}>
                {stat.icon}
              </div>
              <div className="stat-info">
                <p className="stat-label">{stat.label}</p>
                <p className="stat-value">{stat.value}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="dashboard-info">
          <div className="info-card">
            <h2 className="info-title">Welcome to Admin Portal</h2>
            <p className="info-text">
              Manage all aspects of the Cascade India website from this dashboard. Use the sidebar to navigate to different sections.
            </p>
            <ul className="info-list">
              <li>Update founder profiles and information</li>
              <li>Manage services and their descriptions</li>
              <li>Add or edit project showcases</li>
              <li>Post and manage job openings</li>
              <li>View and respond to contact messages</li>
            </ul>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;
